import React from 'react';
import Banner from '../Components/Banner';
import ContactForm from '../ContactForm/ContactFrom';
import { useLanguage } from '../context/LanguageContext';

function Contact() {
  const { t } = useLanguage();

  return (
    <div className="page-wrap contact-page">
      <Banner
        pageName={t.pages.contact}
        pageLink="/contact"
        subtitle={t.contact.pageIntro}
        eyebrow="Innovative Horizons"
        image="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1800&q=80"
      />

      <section className="section contact-section">
        <div className="container">
          <div className="contact-grid">
            <aside className="contact-sidebar">
              <div className="section-title">
                <div className="eyebrow">Contact</div>
                <h2>Compártenos tu idea y abriremos tu correo con el área adecuada para continuar la conversación.</h2>
              </div>

              <p className="body-copy">
                We help institutions, companies and organizations structure digital
                products, tokenization initiatives, academic validation systems and
                Web3 experiences with a refined corporate presentation.
              </p>

          
            </aside>

            <div className="contact-main-form">
              <div className="contact-form-card">
                <div className="form-card-head">
                  <div className="eyebrow">Innovative Horizons</div>
                  <h2>Cuéntanos tu proyecto</h2>
                  <p>
                    La estructura del mensaje se arma automáticamente según el servicio
                    seleccionado.
                  </p>
                </div>

                <ContactForm />
              </div>
            </div>

            
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;